import { SvgBase } from "../svg.base";

export const Twitter = () => (
  <SvgBase>
      <path
      fill="currentColor"
      d="M26 8.114a9.013 9.013 0 0 1-2.591.711 4.532 4.532 0 0 0 1.983-2.495 9.098 9.098 0 0 1-2.867 1.096 4.513 4.513 0 0 0-7.69 4.115 12.813 12.813 0 0 1-9.302-4.716c-.39.665-.61 1.44-.61 2.268A4.51 4.51 0 0 0 6.93 12.85a4.513 4.513 0 0 1-2.045-.566v.056a4.518 4.518 0 0 0 3.62 4.425 4.571 4.571 0 0 1-1.19.158c-.29 0-.572-.029-.849-.084a4.515 4.515 0 0 0 4.215 3.135 9.055 9.055 0 0 1-5.605 1.929c-.364 0-.723-.022-1.076-.062a12.757 12.757 0 0 0 6.918 2.03c8.302 0 12.84-6.876 12.84-12.84l-.015-.584A9.012 9.012 0 0 0 26 8.114z"
    />
  </SvgBase>
);




